import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ICustomMeasure } from '../../models/iannotation';
import { EcgMeasuresService } from '../../utils/ecg-measures.service';

interface IMeasureGroup {
    categoryName: string;
    order: number;
    measures: Array<ICustomMeasure>;
}

@Component({
    selector: 'custom-measures',
    templateUrl: './custom-measures.component.html',
    styleUrls: ['./custom-measures.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CustomMeasuresComponent {
    // events

    @Output()
    toggleChange = new EventEmitter<boolean>();
    @Output()
    closeClicked = new EventEmitter<any>();
    @Output()
    measureChange = new EventEmitter<ICustomMeasure>();

    // data members

    @Input()
    showCloseButton: boolean = true;
    @Input()
    readOnly: boolean = false;

    private _measures: Array<ICustomMeasure> = [];
    get measures() {
        return this._measures;
    }
    @Input()
    set measures(measures) {
        this._measures = measures;
        if (this._measures == null) {
            this._groups = null;
            return;
        }

        this.updateMeasureGroups(this._measures);
        this.updateMeasures();
    }

    private _groups: Array<IMeasureGroup> | null = null;
    get groups() {
        return this._groups;
    }

    get group0(): IMeasureGroup | null {
        return !!this._groups && this._groups.length > 0 ? this._groups[0] : null;
    }
    get group1(): IMeasureGroup | null {
        return !!this._groups && this._groups.length > 1 ? this._groups[1] : null;
    }
    get group2(): IMeasureGroup | null {
        return !!this._groups && this._groups.length > 2 ? this._groups[2] : null;
    }

    calculatedValue: { value: number } | null = null;

    constructor(private ecgMeasuresService: EcgMeasuresService) {}

    // public functions

    updateMeasures() {
        this.ecgMeasuresService.updateMeasures(this.measures);
    }

    onValueChange(measure: ICustomMeasure) {
        measure.isManualModified = true;
        this.measureChange.emit(measure);
        this.updateMeasures();
    }

    onPrintableChange(measure: ICustomMeasure) {
        this.measureChange.emit(measure);
    }

    onToggleChange(isOpen: boolean) {
        this.toggleChange.emit(isOpen);
    }

    onClose() {
        this.closeClicked.emit();
    }

    // private functions

    private updateMeasureGroups(measures: Array<ICustomMeasure>) {
        const categoryIds = measures.map<string>((measure) => measure.category.id);
        let categoryGroups = categoryIds.filter(
            (categoryId, index, array) => categoryId && array.indexOf(categoryId) === index,
        );

        this._groups = new Array<IMeasureGroup>();
        categoryGroups.forEach((categoryId) => {
            let customMeasures = this.measures.filter((measure) => measure.category.id === categoryId);
            let measureGroup: IMeasureGroup = {
                categoryName: customMeasures[0].category.description,
                measures: customMeasures,
                order: customMeasures[0].category.order,
            };

            this._groups?.push(measureGroup);
        });

        this._groups.sort((a, b) => {
            if (a.order < b.order) {
                return -1;
            }
            if (a.order > b.order) {
                return 1;
            }

            return 0;
        });
    }
}
